import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { EnvironmentProvider } from '@/contexts/EnvironmentContext';
import { AuthProvider } from '@/contexts/AuthContext';
import AdminLayout from '@/components/layout/AdminLayout';
import LoginPage from '@/pages/LoginPage';
import UsersPage from '@/pages/UsersPage';
import EnterprisesPage from '@/pages/EnterprisesPage';
import TeamsPage from '@/pages/TeamsPage';
import SeedsPage from '@/pages/SeedsPage';
import SupportPage from '@/pages/SupportPage';
import PlansPage from '@/pages/PlansPage';
import StripeSyncPage from '@/pages/StripeSyncPage';
import PlatformLLMPage from '@/pages/PlatformLLMPage';
import PerfTestsPage from '@/pages/PerfTestsPage';
import PilotApplicationsPage from '@/pages/PilotApplicationsPage';
import SettingsPage from '@/pages/SettingsPage';
import ContractPage from '@/pages/ContractPage';
import ProtectedRoute from '@/components/ProtectedRoute';

export default function App() {
  return (
    <EnvironmentProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route element={<ProtectedRoute />}>
              <Route element={<AdminLayout />}>
                <Route index element={<Navigate to="/users" replace />} />
                <Route path="/users" element={<UsersPage />} />
                <Route path="/enterprises" element={<EnterprisesPage />} />
                <Route path="/enterprises/:enterpriseId/contract" element={<ContractPage />} />
                <Route path="/teams" element={<TeamsPage />} />
                <Route path="/seeds" element={<SeedsPage />} />
                <Route path="/support" element={<SupportPage />} />
                <Route path="/plans" element={<PlansPage />} />
                <Route path="/stripe-sync" element={<StripeSyncPage />} />
                <Route path="/platform-llm" element={<PlatformLLMPage />} />
                <Route path="/perf-tests" element={<PerfTestsPage />} />
                <Route path="/pilot-applications" element={<PilotApplicationsPage />} />
                <Route path="/settings" element={<SettingsPage />} />
              </Route>
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
      </AuthProvider>
    </EnvironmentProvider>
  );
}
